import { z } from 'zod';

export function createStandardNotificationData<T extends z.ZodRawShape>(
  extendedData: T
) {
  return z
    .object({
      type: z.string(),
    })
    .extend(extendedData);
}
export type TStandardNotificationData = z.infer<
  ReturnType<typeof createStandardNotificationData<any>>
>;
